import { SxProps, Theme } from '@mui/material';

export const errorBoundaryStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    p: 2,
    textAlign: 'center',
    bgcolor: 'background.paper',
    boxSizing: 'border-box',
  } as SxProps<Theme>,

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1.25,
    maxWidth: '280px',
    width: '100%',
  } as SxProps<Theme>,

  warningRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontSize: '14px',
    fontWeight: 500,
  } as SxProps<Theme>,

  warningIcon: {
    fontSize: '18px',
    opacity: 0.8,
  } as SxProps<Theme>,

  // Override body2's default secondary color to primary for error messages
  errorText: {
    fontWeight: 500,
    color: 'text.primary',
  } as SxProps<Theme>,

  retryButton: {
    fontSize: '12px',
    fontWeight: 500,
    px: 1.75,
    py: 0.75,
  } as SxProps<Theme>,
};
